module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("LIST OF MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map1"
    }
  }, [_vm._v("1. The conquests of Islam by 750, and towns with large Jewish communities")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map2"
    }
  }, [_vm._v("2. Jewish communities in the Arabian Peninsula at the time of Mohammed")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map3"
    }
  }, [_vm._v("3. Jewish traders in the Eighth and Ninth Centuries")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map4"
    }
  }, [_vm._v("4. Jewish communities in Spain during Muslim rule, 711–1236")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map5"
    }
  }, [_vm._v("5. Jews seeking refuge in Muslim lands from Christian persecution, 1012–1540")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map6"
    }
  }, [_vm._v("6. The Ottoman Empire in 1850")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map7"
    }
  }, [_vm._v("7. Jewish communities in Ottoman Palestine by 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map8"
    }
  }, [_vm._v("8. Birthplaces of Jews born in Muslim lands, deported to their deaths from France, 1942–1944")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map9"
    }
  }, [_vm._v("9. Former Jewish communities in Morocco")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map10"
    }
  }, [_vm._v("10. Former Jewish communities in Algeria and the area around Algiers")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map11"
    }
  }, [_vm._v("11. Former Jewish communities in Tunisia")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map12"
    }
  }, [_vm._v("12. Former Jewish communities in Libya")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map13"
    }
  }, [_vm._v("13. Former Jewish communities in Egypt")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map14"
    }
  }, [_vm._v("14. Former Jewish communities in Lebanon")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map15"
    }
  }, [_vm._v("15. Former Jewish communities in Syria")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map16"
    }
  }, [_vm._v("16. Former Jewish communities in Iraq")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map17"
    }
  }, [_vm._v("17. Former Jewish communities in Iran")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map18"
    }
  }, [_vm._v("18. Former Jewish communities in Afghanistan and the Khanate of Bukhara")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map19"
    }
  }, [_vm._v("19. Former Jewish communities in Yemen")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm#map20"
    }
  }, [_vm._v("20. The ‘Second Exodus,’ 1947–1957")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-626523bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/listofmap.vue
// module id = 75
// module chunks = 0